/**
 * Copyright (c) 2024 The Diffusion Studio Authors
 *
 * This Source Code Form is subject to the terms of the Mozilla 
 * Public License, v. 2.0 that can be found in the LICENSE file.
 */

export const FPS_DEFAULT = 30;

export const FPS_OPTIONS = [
    23.98,
    24,
    25,
    29.97,
    30,
    50,
    59.94,
    60,
];